import { moduleName as parentModuleName } from '../constants';

export const moduleName = 'startAdvancement';
export const modulePath = [parentModuleName, moduleName];
